// Events from application.js were moved to this file as part of reorganization process.
// All of them should be moved to anouther place. Don't add new events to this file!
import $ from 'jquery'

$(document).ready(function() {
  var $censorForm;

  function init() {
    $censorForm = $('.censor form.button_to');

    $('.w-flexible-header').wFlexibleHeader();
    $('.flexible__breadcrumbs-container').breadcrumbsFlexible();

    // stubbing out console log for non-Firebug enabled browsers
    if (!window.console) {
      window.console = { log: function() { return true; } };
    }

    // Show Flash Message popup if needed
    showFlashPopup();

    bindDomEvents();
    bindCensorButton();
  }

  // Bind DOM events
  function bindDomEvents() {
    // Close Overlays on Unload
    $(window).on('unload', function() {
      SOPHIA.closeOverlayBox();
    });
  }

  function bindCensorButton() {
     $censorForm.on('submit', function() {
      $('input[type=submit], button[type=submit]', $(this)).addClass("disabled").prop('disabled', true);
    });
  }

  // Shows Flash Popup if needed
  function showFlashPopup() {
    var $flashMessageBlock = $('.flash');

    if ( $flashMessageBlock.length > 0 ) {
      var type = '';

      if ( $flashMessageBlock.hasClass('flash_error') )   type = 'error';
      if ( $flashMessageBlock.hasClass('flash_warning') ) type = 'notice';
      if ( $flashMessageBlock.hasClass('flash_notice') )  type = 'success';

      SOPHIA.flashMessage( $('.flash').html(), type );
      $('.flash').remove();
    }
  }

  init();
});
